export const COOKIE_EXPIRATION_TIME = 60 * 1000 // 1 min
